// Consultants page static structure. Display strings in translation/{ua,en}.json
// under the `Consultants` namespace (Service1*, Service2*, Review*).
// Gallery images are referenced by blog-media ObjectId and resolved at runtime
// via GET /media?ids=... which returns { [id]: fullPath }.

const CONSULTANT_SERVICES = [
  {
    key: 'Service1',
    stepKeys: ['Service1Step1', 'Service1Step2', 'Service1Step3'],
    outcomeKeys: ['Service1Outcome1', 'Service1Outcome2']
  },
  {
    key: 'Service2',
    stepKeys: ['Service2Step1', 'Service2Step2'],
    outcomeKeys: ['Service2Outcome1']
  }
];

const CONSULTANT_REVIEWS = [
  { id: 'review-1', imageGallery: '68fb6715eecb3dbe50bc35c2', descriptionKey: 'Review1' },
  { id: 'review-2', imageGallery: '68fb670aeecb3dbe50bc3593', descriptionKey: 'Review2' },
  { id: 'review-3', imageGallery: '68fb66f8eecb3dbe50bc3520', descriptionKey: 'Review3' }
];

export { CONSULTANT_SERVICES, CONSULTANT_REVIEWS };
